import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Typography, Grid } from '@mui/material';

import AuthContext from '../../contexts/authContext';

import styles from './SubMenu.module.scss';

const SubMenu = () => {
  const { planFeatures } = useContext(AuthContext);

  const { areLocalDomainsAvailable, areAgentsActiveDirectoryAvailable } =
    planFeatures;

  return (
    <div className={styles['sub-menu']}>
      <Grid container>
        <Grid item>
          <NavLink
            to="releases"
            className={({ isActive }) => {
              const activeCls = isActive ? 'active' : '';

              return `${styles['sub-menu-item']} ${styles[activeCls]}`;
            }}
          >
            <Typography variant="body2" component="span">
              Agent release
            </Typography>
          </NavLink>
        </Grid>
        <Grid item>
          <NavLink
            to="users"
            className={({ isActive }) => {
              const activeCls = isActive ? 'active' : '';

              return `${styles['sub-menu-item']} ${styles[activeCls]}`;
            }}
          >
            <Typography variant="body2" component="span">
              Users
            </Typography>
          </NavLink>
        </Grid>
        {areAgentsActiveDirectoryAvailable ? (
          <Grid item>
            <NavLink
              to="collections"
              className={({ isActive }) => {
                const activeCls = isActive ? 'active' : '';

                return `${styles['sub-menu-item']} ${styles[activeCls]}`;
              }}
            >
              <Typography variant="body2" component="span">
                Collections
              </Typography>
            </NavLink>
          </Grid>
        ) : null}
        {areLocalDomainsAvailable || areAgentsActiveDirectoryAvailable ? (
          <Grid item>
            <NavLink
              to="deploy"
              className={({ isActive }) => {
                const activeCls = isActive ? 'active' : '';

                return `${styles['sub-menu-item']} ${styles[activeCls]}`;
              }}
            >
              <Typography variant="body2" component="span">
                Deploy
              </Typography>
            </NavLink>
          </Grid>
        ) : null}
      </Grid>
    </div>
  );
};

export default SubMenu;
